import React from 'react';
import { useSelector } from 'react-redux';
import { getRregionalnoeOtdelenieFromRoles } from '../../../common/Tool';
import PromokodiBlock from '../../components/PromokodiBlock'
import PageLayout from '../../components/PageLayout';
import { GET, errorCatch, useAuth } from 'fennec-ui';
import { useLocaladminContext } from '../../../common/Context';

export default function LocaladminComissionPromocodes(props) {
    const local = useLocaladminContext();
    // const regionalnoeOtdelenie = useSelector(getRregionalnoeOtdelenieFromRoles(["АдминистраторОтделения", "АдминистраторМероприятийРО"], true));
    const auth = useAuth()
    // const [regionalnoeOtdelenie, setRegionalnoeOtdelenie] = React.useState([])
    // React.useEffect(()=>{
    //     GET(auth, '/api/ro/list-by-admin', ({data})=>{
    //         setRegionalnoeOtdelenie(data);
    //     }, errorCatch)
    // }, [])

    return (
        <PageLayout>
        <PromokodiBlock {...props} source={"/api/promokodi/list/reg?detail=model"}
            sourceKey="reg"
            create={true}
            ctx={{organizatorRegionalnoeOtdelenieID: local?.ID}}
            // context={{
            //     collection: regionalnoeOtdelenie,
            //     name: (item) => item.nazvanie,
            //     mix: (item) => {
            //         return {
            //             // organizatorFederatsiyaID: 1, // Организатор федерация
            //             // organizatorShkolaID: ID, // Организатор школа
            //             // organizatorMeropriyatiyaID: ID, // Организатор мероприятия
            //             organizatorRegionalnoeOtdelenieID: item.ID // Организатор региональное отделение
            //         }
            //     }
            // }}
        />
        </PageLayout>
    );
}
